import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

export const addVendor = async (vendorData) => {
  try {
    const response = await axios.post(`${API_URL}/vendors`, vendorData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getAllVendors = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/vendors`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateVendorStatus = async (id, vendorStatus) => {
  try {
    const response = await axios.put(`${API_URL}/vendors/${id}/status`, { vendor_status: vendorStatus });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateVendor = async (id, vendorData) => {
  try {
    const response = await axios.put(`${API_URL}/vendors/${id}`, vendorData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
